import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=48b4df84"
import script from "./ColorPickerButton.js?vue&type=script&lang=js&external"
export * from "./ColorPickerButton.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports